import type { TFunction } from 'i18next';

const FIRST_USE_KEY = 'dg_grade_hub_first_use_v1';
const SUBMISSION_COUNT_KEY = 'dg_grade_hub_submission_count_v1';

export function recordFirstUseIfNeeded(): void {
  try {
    if (!localStorage.getItem(FIRST_USE_KEY)) {
      localStorage.setItem(FIRST_USE_KEY, String(Date.now()));
    }
  } catch {
    // ignore
  }
}

export function bumpSubmissionCount(delta = 1): void {
  try {
    const raw = localStorage.getItem(SUBMISSION_COUNT_KEY);
    const n = raw ? Math.max(0, parseInt(raw, 10) || 0) : 0;
    localStorage.setItem(SUBMISSION_COUNT_KEY, String(n + delta));
  } catch {
    // ignore
  }
}

export function getDaysSinceFirstUse(): number | null {
  try {
    const raw = localStorage.getItem(FIRST_USE_KEY);
    if (!raw) return null;
    const ts = parseInt(raw, 10);
    if (!Number.isFinite(ts)) return null;
    return Math.floor((Date.now() - ts) / (24 * 60 * 60 * 1000));
  } catch {
    return null;
  }
}

export function getSubmissionCount(): number {
  try {
    const raw = localStorage.getItem(SUBMISSION_COUNT_KEY);
    return raw ? Math.max(0, parseInt(raw, 10) || 0) : 0;
  } catch {
    return 0;
  }
}

export type RetentionHintInput = {
  daysSinceFirstUse: number | null;
  submissionCount: number;
  remaining: number;
  progressPct: number;
};

/**
 * Motivational one-liner for the hub status row — local dates/counts only.
 */
export function getRetentionMotivationCopy(t: TFunction, input: RetentionHintInput): string {
  const { daysSinceFirstUse, submissionCount, remaining, progressPct } = input;

  if (remaining === 0 && progressPct >= 100) {
    return t('gradeHub.retention.allCaughtUp');
  }
  if (remaining > 0 && remaining <= 3) {
    return t('gradeHub.retention.almostDone', { count: remaining });
  }
  if (progressPct >= 75) {
    return t('gradeHub.retention.onARoll');
  }
  if (daysSinceFirstUse !== null && daysSinceFirstUse >= 6 && submissionCount >= 5) {
    return t('gradeHub.retention.weekStreak');
  }
  if (daysSinceFirstUse !== null && daysSinceFirstUse <= 2 && submissionCount < 3) {
    return t('gradeHub.retention.welcomeBack');
  }
  if (submissionCount >= 20) {
    return t('gradeHub.retention.buildingHabit');
  }
  return t('gradeHub.retention.keepGoing');
}
